

































































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import {RoleScope} from '@/views/administration/roles/interfaces';

@Component({
  components: {EditDialog},
})
export default class RoleEditDialog extends Mixins(EditDialogMixin) {
  errorKeyList = {
    name: 'name',
  };

  get scopesList(): RoleScope[] {
    return this.data.scopes;
  }

  onChange(value: boolean | null) {
    if (value === null) {
      return;
    }
    this.data.scopes = this.scopesList;
  }
}
